/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Read-only classification for events cancelled because the creator did not attend
 */

export const NoShowCheckInsFilter = {
  None: 'none',
  Some: 'some',
  Unknown: 'unknown'
} as const

export type NoShowCheckInsFilter = (typeof NoShowCheckInsFilter)[keyof typeof NoShowCheckInsFilter]
